module.exports = __webpack_public_path__ + "img/planet-saturn.38ee5a7d.svg";